import { Component, OnInit, Input, ViewChild} from '@angular/core';
import { environment } from './../../../environments/environment';

// plugin
import { SlickCarouselComponent } from 'ngx-slick-carousel';

// service
import { GlobalService } from '../../shared/service/global.service';
import { ApiService } from 'src/app/shared/service/api.service';

@Component({
  selector: 'app-two-way-slider',
  templateUrl: './two-way-slider.component.html'
})
export class TwoWaySliderComponent implements OnInit {

  @Input() dataTwoSlider;
  @Input() versi = '1';
  @ViewChild('slickModal') slickModal: SlickCarouselComponent;
  @Input() curData;
  @Input() curDataDesc;
  isLang;
  apiAsset = environment.API_ASSETS;
 
  constructor( private globalService : GlobalService, private apiService: ApiService ) { }

  ngOnInit(): void {
    //MultiLanguage
   this.isLang =  this.apiService.isLang();
  }

  slideConfig = {
    "slidesToShow": 1, 
    "slidesToScroll": 1,
    "arrows": false
  };

  afterChange(e) {
    this.curData = this.dataTwoSlider.content[e.currentSlide];
    this.curDataDesc = this.globalService.trimString2(this.dataTwoSlider.content[e.currentSlide].metadesc, 85);
  }

  next() {
    this.slickModal.slickNext();
  }

  prev() {
    this.slickModal.slickPrev();
  }
}
